import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';

export const getActiveAnalysisSet = createSelector(
  (state: RootState) => state.analysisSets.sets,
  (state: RootState) => state.analysisSets.activeAnalysisSetGuid,
  (analysisSets, activeAnalysisSetGuid) => {
    const activeAnalysisSet = analysisSets.find((analysisSet) => analysisSet.guid === activeAnalysisSetGuid);

    if (activeAnalysisSet === undefined) return null;
    return activeAnalysisSet;
  },
);
